/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

export type ServiceCreateAnnualWorksPlanEvaluationInputAllOfType = typeof ServiceCreateAnnualWorksPlanEvaluationInputAllOfType[keyof typeof ServiceCreateAnnualWorksPlanEvaluationInputAllOfType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceCreateAnnualWorksPlanEvaluationInputAllOfType = {
  'annual-works-plan-evaluation': 'annual-works-plan-evaluation',
} as const;
